import { render, staticRenderFns } from "./KZGReportSentEmailEdit.vue?vue&type=template&id=f5afafde&scoped=true"
import script from "./KZGReportSentEmailEdit.vue?vue&type=script&lang=js"
export * from "./KZGReportSentEmailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5afafde",
  null
  
)

export default component.exports